<template>
  <div class="mt-2 w-full">
    <div class="flex items-center justify-between mb-0.5 md:mb-1">
      <span :class="['text-[8px] md:text-[10px] font-serif-body font-bold uppercase tracking-tighter', isEasy ? 'text-amber-900' : 'text-amber-300']">
        Bonus
      </span>
      <span :class="['text-[8px] md:text-[10px] font-serif-display font-bold px-1 rounded', isEasy ? 'bg-amber-200 text-amber-900' : 'bg-amber-900/40 text-amber-400']">
        +{{ (streakBonusPercent * 100).toFixed(0) }}%
      </span>
    </div>
    <div class="w-full h-1 md:h-1.5 bg-black/20 rounded-full overflow-hidden border" :class="isEasy ? 'border-amber-800/20' : 'border-amber-600/20'">
      <div 
        class="h-full transition-all duration-500 ease-out relative"
        :class="[
          streakProgress >= 100 ? 'bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400 animate-pulse' : 'bg-gradient-to-r from-amber-600 to-amber-400',
          isEasy ? 'opacity-90' : 'opacity-100'
        ]"
        :style="{ width: `${streakProgress}%` }"
      >
        <div class="absolute inset-0 bg-gradient-to-b from-white/30 to-transparent"></div>
      </div>
    </div>
    <div v-if="streakProgress >= 100" class="mt-0.5 flex justify-center items-center gap-1">
      <span class="text-[10px] animate-bounce">🔥</span>
      <span :class="['text-[8px] font-serif-body font-bold uppercase italic', isEasy ? 'text-amber-800' : 'text-amber-400']">MAX</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  streakProgress: {
    type: Number,
    required: true
  },
  streakBonusPercent: {
    type: Number,
    required: true
  },
  isEasy: {
    type: Boolean,
    default: false
  }
})
</script>
